import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import _ from 'lodash';
import moment from 'moment';
import { DATE_FORMATS, showError } from 'utils';
import { fetchHistoryForInventoryItemQuantityGraph } from 'services';

const ItemHistoryChart = (props) => {
  const { historyData } = props;
  const [historyLogs, setHistoryLogs] = useState<Record<string, any>>({});
  const fetchInventoryItemQuantityHistoryFn = async () => {
    try {
      const response = await fetchHistoryForInventoryItemQuantityGraph(historyData);
      setHistoryLogs(response);
    } catch (e) {
      showError(e);
    }
  };

  useEffect(() => {
    fetchInventoryItemQuantityHistoryFn();
  }, [historyData.startDate, historyData.endDate]);

  const data = getFormattedData(historyLogs.items);
  const options = {
    title: {
      text: 'Item Change History',
    },
    series: [{ data, name: 'Quantity at point' }],
    yAxis: {
      title: {
        text: 'Quantity',
      },
    },
    xAxis: {
      title: {
        text: 'Time Period',
      },
      type: 'datetime',
      labels: {
        formatter: function () {
          const ctx: any = this;
          return data[ctx.value][0];
        },
      },
      step: 2,
    },
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

const getXaxisLabelData=(value)=>{
  if(value.day && value.year){
    return 'day '+value.day + ' '+ value.year;
  }
  if(value.week && value.year){
    return 'week '+value.week + ' '+ value.year;
  }
  if(value.month && value.year){
    return 'month '+value.month + ' '+ value.year;
  }
  return value.year;
};

const getFormattedData = (historyLogItems = []) => {
  return _.map(historyLogItems, (value: any, index) => {
    const ms=getXaxisLabelData(value.objectId);
    return [ms, _.get(value, 'updated')];
  });
};

export default ItemHistoryChart;
